import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import Dashboard from './Dashboard';
import Login from './Login';
import OrderRegist from './OrderRegist';
import OrderRegist_individual from './OrderRegist_individual';
import OrderList from './OrderList';
import OrderTechnician from './OrderTechnician';
import Nav from './Navbar';
import Sidebar from './Sidebar';
import Mon from './Mon';
import Mon2 from './Mon2';

function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [gu, setGu] = useState("");
  const [bcuCode, setBcuCode] = useState("");
  const [bcuName, setBcuName] = useState("");
  const [systemYN, setSystemYN] = useState("");
  const [currentPath, setCurrentPath] = useState("/");

  useEffect(() => {
    const storedUserId = sessionStorage.getItem('userId');
    const storedUsername = sessionStorage.getItem('username');
    const storedGu = sessionStorage.getItem('gu');
    const storedBcuCode = sessionStorage.getItem('bcuCode');
    const storedBcuName = sessionStorage.getItem('bcuName');
    const storedSystemYN = sessionStorage.getItem('systemYN');
    const storedPath = sessionStorage.getItem('currentPath') || '/Dashboard';

    if (storedUserId && storedUsername && storedBcuCode) {
      setIsLoggedIn(true);
      setUserId(storedUserId);
      setUsername(storedUsername);
      setBcuCode(storedBcuCode);
      setGu(storedGu);
      setBcuName(storedBcuName);
      setSystemYN(storedSystemYN);
      setCurrentPath(storedPath);
    }
  }, []);

  const handleLoginSuccess = (userId, username, gu, bcuCode, bcuName, systemYN) => {
    setIsLoggedIn(true);
    setUserId(userId);
    setUsername(username);
    setBcuCode(bcuCode);
    setGu(gu);
    setBcuName(bcuName);
    setSystemYN(systemYN);

    sessionStorage.setItem('userId', userId);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('gu', gu);
    sessionStorage.setItem('bcuCode', bcuCode);
    sessionStorage.setItem('bcuName', bcuName);
    sessionStorage.setItem('systemYN', systemYN);
    sessionStorage.setItem('currentPath', '/Dashboard');
    setCurrentPath('/Dashboard');
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setIsLoggedIn(false);
    setUserId("");
    setUsername("");
    setBcuCode("");
    setGu("");
    setBcuName("");
    setSystemYN("");
    setCurrentPath("/");
  };

  const handleMenuClick = (path) => {
    setCurrentPath(path);
    sessionStorage.setItem('currentPath', path);
  };

  return (
    <BrowserRouter>

      <Routes>

        {/* 🔥 MON 전용 화면 */}
        <Route path="/mon" element={<Mon />} />
        <Route path="/mon2" element={<Mon2 />} />

        {/* 로그인 영역 */}
        <Route
          path="/*"
          element={
            <>
              {isLoggedIn && (
                <Nav
                  userId={userId}
                  username={username}
                  bcuCode={bcuCode}
                  bcuName={bcuName}
                  gu={gu}
                  onLogout={handleLogout}
                />
              )}

              {isLoggedIn && (
                <Sidebar gu={gu} systemYN={systemYN} onMenuClick={handleMenuClick} />
              )}

              <div className={`content-wrap ${isLoggedIn ? '' : 'no-padding'}`}>
                <Routes>

                  <Route
                    path="/"
                    element={
                      isLoggedIn ? (
                        <Navigate to={currentPath} replace />
                      ) : (
                        <Login onLoginSuccess={handleLoginSuccess} />
                      )
                    }
                  />

                  <Route
                    path="/Dashboard"
                    element={
                      isLoggedIn ? (
                        <Dashboard bcuCode={bcuCode} systemYN={systemYN} />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />

                  <Route
                    path="/OrderRegist"
                    element={
                      isLoggedIn ? (
                        <OrderRegist
                          username={gu === '1' ? username : '기공사 선택'}
                          userId={userId}
                          bcuCode={bcuCode}
                          bcuName={bcuName}
                          systemYN={systemYN}
                          gu={gu}
                        />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />

                  <Route
                    path="/OrderRegist_individual"
                    element={
                      isLoggedIn ? (
                        <OrderRegist_individual
                          username={gu === '1' ? username : '기공사 선택'}
                          userId={userId}
                          bcuCode={bcuCode}
                          bcuName={bcuName}
                          systemYN={systemYN}
                          gu={gu}
                        />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />

                  <Route
                    path="/OrderList"
                    element={
                      isLoggedIn ? (
                        <OrderList bcuCode={bcuCode} systemYN={systemYN} />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />

                  <Route
                    path="/OrderTechnician"
                    element={
                      isLoggedIn && gu !== '1' ? (
                        <OrderTechnician bcuCode={bcuCode} />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />

                </Routes>
              </div>
            </>
          }
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;
